import { render, staticRenderFns } from "./LoginPopupThirdPartyGlobal.vue?vue&type=template&id=936d2fd6&scoped=true&"
import script from "./LoginPopupThirdPartyGlobal.vue?vue&type=script&lang=js&"
export * from "./LoginPopupThirdPartyGlobal.vue?vue&type=script&lang=js&"
import style0 from "./LoginPopupThirdPartyGlobal.vue?vue&type=style&index=0&id=936d2fd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936d2fd6",
  null
  
)

component.options.__file = "LoginPopupThirdPartyGlobal.vue"
export default component.exports